import { Container } from "@chakra-ui/react";
import styles from "./reviews.module.scss";
import CompanyReview from "../../components/references";

export type Review = {
  name: string;
  position: string;
  image: string;
  review: string;
  companyData: CompanyData;
};

type CompanyData = {
  name: string;
  logo: string;
  description: string;
};

const xeliaReview = `### Industrial AI in Action – Leading Global Supplier of API’s dramatically improve cost-of-goods-sold (COGS) and operator satisfaction

Together with the BioLean Team we are deploying some of the most advanced and ambitious dynamic fermentation and purification prediction and planning models in the pharma industry. We are leveraging BioLean’s creative expertise in developing and implementing advanced real-time prediction tools with actionable information displayed in our control rooms to aid day-to-day manufacturing of API’s. Apart from significant improvements in execution and highly satisfied operational staff we have also demonstrated an increase in yield and improved capacity utilization hence realizing an improved cash-flow from production.

Personally, I have enjoyed and continue to enjoy working with the BioLean team. I am involved in several production optimization projects with BioLean at our fermentation site in Copenhagen and they just do a fantastic job. Combining our domain knowledge with BioLean’s AI competences and agile mindset delivers value to Xellia. For me this is the future of lean Biotech. Obviously, it requires the right team to succeed and BioLean is a great team. It is very satisfying to collaborate and deliver value with such experts.`;

const companyReviews: Review[] = [
  {
    name: "Kim Ekelund-Ottow, PhD",
    position: "Fermentation Specialist at Xellia Pharmaceuticals, Copenhagen",
    image: "/media/images/Xellia_Kim.jpg",
    review: xeliaReview,
    companyData: {
      name: "Xellia Pharmaceuticals",
      logo: "/media/images/xellia-logo.png",
      description: `Xellia Pharmaceuticals is a leading global supplier of several established and essential anti-infective products.
      The Copenhagen Xellia site is the Company’s largest operational site manufacturing sterile APIs and FDFs.
      Fermentation is a key competence at Xellia.`,
    },
  },
];

const Reviews = () => {
  return (
    <div
      className={`sectionContainer ${styles.reviewContainer}`}
      id="references"
    >
      <Container>
        <h2 className={`sectionSubtitle ${styles.subtitle}`}>
          What our customers say
        </h2>
        {companyReviews.map((review, index) => (
          <CompanyReview review={review} key={index} />
        ))}
      </Container>
    </div>
  );
};

export default Reviews;
